import { Menu, Transition } from '@headlessui/react'
import {FC, Fragment, ReactElement} from "react";
import {Link} from "react-router-dom";

export interface IMenu {
    href: string | (() => void),
    label: string|ReactElement,
    isExtern?:boolean
}

interface Props {
    triggerElement: ReactElement;
    items: IMenu[];
}

const Dropdown: FC<Props> = (props) => {
    return (
        <Menu as='div' className='relative inline-block text-left'>
            <Menu.Button>
                {props.triggerElement}
            </Menu.Button>
            <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
            >
                <Menu.Items className='absolute left-0 w-56 mt-2 origin-top-left shadow-lg rounded-lg bg-gray-200 text-black dark:text-white dark:bg-mainGray divide-y divide-white/5 overflow-hidden'>
                    {props.items.map((x,i) => (
                        <Menu.Item key={i}>
                            {({ active }) => (
                                typeof x.href === 'function' ? (
                                    <button className={`w-full block px-2 py-2 z-50 ${active && 'bg-secondary text-white'}`} onClick={() => (x.href as Function)()}>
                                        {x.label}
                                    </button>
                                ) : (
                                    <Link
                                        className={`w-full block px-2 py-2 z-50 ${active && 'bg-secondary text-white'}`}
                                        to={x.href}
                                    >
                                        {x.label}
                                    </Link>
                                )
                            )}
                        </Menu.Item>
                    ))}
                </Menu.Items>
            </Transition>

        </Menu>
    )
}

export default Dropdown;